<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils/shadcn/lib/utils';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    class?: HTMLAttributes['class']
}>();
</script>

<template>
    <fieldset
        data-slot="field-set"
        :class="cn(
            'flex flex-col *:[[data-slot=field-description]+[data-slot=field-group]]:mt-5',
            'has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3',
            props.class,
        )"
    >
        <slot></slot>
    </fieldset>
</template>
